export default "__VITE_ASSET__CRs$1Z0K__"